import React, { FunctionComponent, MouseEvent } from "react";
import { useIntl } from "react-intl";
import HeaderHighlight from "@Components/atoms/header/HeaderHighlight";
import HeaderSubCategory from "@Components/atoms/header/HeaderSubCategory";
import {
  AssetHighlight,
  Category,
  PartnershipHighlight,
  ProductHighlight,
  SubCategory,
} from "@Types/header";
import "./style.scss";

interface Props {
  category: Category;
  onMouseLeaveMenu: (event: MouseEvent) => void;
}

const HeaderDropdown: FunctionComponent<Props> = ({ category, onMouseLeaveMenu }) => {
  const intl = useIntl();
  const localeSlug = intl.locale;

  const sortedSubCategories = category.subCategories.sort((a, b) => a.priority - b.priority);

  return (
    <div className="HeaderDropdown-wrapper" onMouseLeave={onMouseLeaveMenu}>
      <div className="HeaderDropdown">
        <div className="HeaderDropdown-subCategories">
          {sortedSubCategories.map((subCategory: SubCategory, index: number) => (
            <HeaderSubCategory key={index} subCategory={subCategory} />
          ))}
        </div>
        <div
          className="HeaderDropdown-highlights"
          style={{ justifyContent: sortedSubCategories.length > 0 ? "flex-end" : "center" }}
        >
          {category.assetHighlights &&
            category.assetHighlights.map((highlight: AssetHighlight, index: number) => (
              <HeaderHighlight key={index} highlight={highlight} />
            ))}
          {category.partnershipHighlights &&
            category.partnershipHighlights.map((highlight: PartnershipHighlight, index: number) => (
              <HeaderHighlight key={index} highlight={highlight} />
            ))}
          {category.productHighlights &&
            category.productHighlights.map((highlight: ProductHighlight, index: number) => (
              <HeaderHighlight key={index} highlight={highlight} />
            ))}
        </div>
        {category.linkText && (
          <a href={`/${localeSlug}${category.url}`} className="HeaderDropdown-all-products">
            {category.linkText}
          </a>
        )}
      </div>
    </div>
  );
};

export default React.memo(HeaderDropdown);
